<template>
  <v-container fluid class="fill-height d-block">
    <div class="pa-2 fill-height d-flex flex-column">
      <v-form
        @submit.prevent="filtersSubmission()"
        class="d-flex align-center mb-3 flex-column flex-sm-row justify-sm-space-between"
      >
        <div class="d-flex justify-between flex-wrap">
          <v-autocomplete
            v-model="filtersObj.userId"
            :items="usernamesList.allItems"
            item-value="id"
            item-text="username"
            prepend-inner-icon="mdi-magnify"
            :label="
              $t('panel.businesses.businessesList.searchBoxesForm.userName')
            "
            class="theme-custom-input input-search user-name"
            outlined
            hide-details
            clearable
            dense
            @change="getBusinessNames"
            :loading="usernamesList.autocompleteListLoading"
            @focus="
              inputSearchCheck($event, service, 'usernamesList', 'username')
            "
            @keyup="inputSearch($event, service, 'usernamesList', 'username')"
            @paste="inputSearch($event, service, 'usernamesList', 'username')"
            @click:clear="
              inputSearch($event, service, 'usernamesList', 'username')
            "
          >
            <!--              <template v-slot:selection="{ item }">-->
            <!--                <span class="gray12&#45;&#45;text pa-0 ma-0">{{ item.username }}</span>-->
            <!--              </template>-->
            <!--                            <template v-slot:item="{ active, item, attrs, on }">-->
            <!--                              <template>-->
            <!--                                <v-list-item v-on="on" #default>-->
            <!--                                  <span class="gray12&#45;&#45;text">{{ item.username }}</span>-->
            <!--                                </v-list-item>-->
            <!--                              </template>-->
            <!--                            </template>-->
            <template v-slot:append-item>
              <div
                v-intersect.quiet="intersectUsernameList"
                class="ms-4"
                v-if="
                  !usernamesList.moreItemsLoading &&
                    usernamesList.displayMoreItem
                "
              >
                ...
              </div>
              <v-progress-circular
                v-else-if="usernamesList.moreItemsLoading"
                :size="20"
                :width="2"
                color="primary"
                indeterminate
                class="d-block mx-auto"
              />
            </template>
          </v-autocomplete>
          <transition mode="out-in" name="route">
            <v-autocomplete
              v-if="filtersObj.userId"
              v-model="filtersObj.businessId"
              :items="businessNamesList.allItems"
              item-value="id"
              item-text="businessName"
              prepend-inner-icon="mdi-magnify"
              :label="
                $t(
                  'panel.businesses.businessesList.searchBoxesForm.businessName'
                )
              "
              class="theme-custom-input input-search business-name"
              outlined
              hide-details
              clearable
              dense
              :loading="businessNamesList.autocompleteListLoading"
              @focus="
                inputSearchCheck(
                  $event,
                  merchantService,
                  'businessNamesList',
                  'businessName',
                  'userId'
                )
              "
              @keyup="
                inputSearch(
                  $event,
                  merchantService,
                  'businessNamesList',
                  'businessName',
                  'userId'
                )
              "
              @paste="
                inputSearch(
                  $event,
                  merchantService,
                  'businessNamesList',
                  'businessName',
                  'userId'
                )
              "
              @click:clear="
                inputSearch(
                  $event,
                  merchantService,
                  'businessNamesList',
                  'businessName',
                  'userId'
                )
              "
            >
              <template v-slot:append-item>
                <div
                  v-intersect.quiet="intersectBusinessList"
                  class="ms-4"
                  v-if="
                    !businessNamesList.moreItemsLoading &&
                      businessNamesList.displayMoreItem
                  "
                >
                  ...
                </div>
                <v-progress-circular
                  v-else-if="businessNamesList.moreItemsLoading"
                  :size="20"
                  :width="2"
                  color="primary"
                  indeterminate
                  class="d-block mx-auto"
                />
              </template>
            </v-autocomplete>
          </transition>

          <v-text-field
            v-model="filtersObj.serialNumber"
            prepend-inner-icon="mdi-magnify"
            :label="
              $t('panel.posManagementPage.searchBoxesForm.posSerialNumber')
            "
            class="theme-custom-input input-search transaction-id"
            outlined
            hide-details
            dense
          />
        </div>

        <div
          class="d-flex justify-space-around align-center align-content-center align-self-sm-end form-buttons"
        >
          <v-btn depressed color="primary" class="ma-3" type="submit">
            {{ $t("panel.posManagementPage.searchBoxesForm.submit") }}
          </v-btn>
          <v-btn outlined color="primary" @click="resetFilters">{{
            $t("panel.posManagementPage.searchBoxesForm.reset")
          }}</v-btn>
        </div>
      </v-form>

      <v-data-table
        fixed-header
        :headers="$t('panel.posManagementPage.table.headers')"
        :items="tableData"
        item-key="id"
        :loading="loading"
        loading-text="Loading... Please wait"
        :page.sync="filtersObj.page"
        :items-per-page="filtersObj.size"
        hide-default-footer
        @page-count="pageCount = $event"
        :class="shortList"
      >
        <template v-slot:item.registerDate="{ item }">
          <div class="text-no-wrap">{{ item.registerDate | $renderDate }}</div>
        </template>
        <template v-slot:item.lastUpdate="{ item }">
          <div class="text-no-wrap">{{ item.lastUpdate | $renderDate }}</div>
        </template>
        <template v-slot:item.gatewayStatus="{ item }">
          <v-chip
            class="transaction-status"
            label
            :color="$transactionStatusColor(item.gatewayStatus).color"
            :text-color="$transactionStatusColor(item.gatewayStatus).textColor"
          >
            {{ item.gatewayStatus }}
          </v-chip>
        </template>
        <template v-slot:item.currencies="{ item }">
          <router-link
            :to="{
              name: 'posGatewayCurrencies',
              params: { gatewayId: item.id }
            }"
            >{{
              $t("panel.posManagementPage.table.content.detail")
            }}</router-link
          >
        </template>
        <template v-slot:item.actions="{ item }">
          <div v-if="item.gatewayStatus === 'ACTIVE'">
            <v-btn
              small
              color="error"
              text
              :loading="submitLoading[item.id] || false"
              @click="openChangeStatusModal(item.id, 'SUSPENDED', 'POS device')"
              class="text-decoration-underline font-medium-12 Btn-in-table"
            >
              {{ $t("panel.posManagementPage.table.content.suspend") }}
            </v-btn>
            <v-btn
              small
              color="warning"
              text
              :loading="submitLoading[item.id] || false"
              @click="openChangeStatusModal(item.id, 'INACTIVE', 'POS device')"
              class="text-decoration-underline font-medium-12 Btn-in-table"
            >
              {{ $t("panel.posManagementPage.table.content.deactivate") }}
            </v-btn>
          </div>
          <div
            v-else-if="
              item.gatewayStatus === 'PENDING' ||
                item.gatewayStatus === 'INACTIVE'
            "
          >
            <v-btn
              small
              color="success"
              text
              :loading="submitLoading[item.id] || false"
              @click="openActivationModal(item)"
              class="text-decoration-underline font-medium-12 Btn-in-table"
            >
              {{ $t("panel.posManagementPage.table.content.activate") }}
            </v-btn>
            <v-btn
              small
              color="error"
              text
              :loading="submitLoading[item.id] || false"
              @click="openChangeStatusModal(item.id, 'SUSPENDED', 'POS device')"
              class="text-decoration-underline font-medium-12 Btn-in-table"
            >
              {{ $t("panel.posManagementPage.table.content.suspend") }}
            </v-btn>
          </div>
        </template>
      </v-data-table>

      <div v-if="tableData.length" class="text-center pt-2">
        <v-pagination
          v-model="filtersObj.page"
          :length="totalPages"
          :total-visible="7"
          prev-icon="< Back"
          next-icon="Next >"
          class="pagination"
          @input="filtersSubmission(true)"
        ></v-pagination>
      </div>
    </div>

    <v-dialog
      v-model="activationModal"
      max-width="450px"
      @click:outside="closeActiveModal"
    >
      <v-btn icon :ripple="false" @click="closeActiveModal">
        <v-icon size="24">mdi-close</v-icon>
      </v-btn>

      <v-form ref="form" @submit.prevent="activatePos" class="pa-6">
        <v-text-field
          autofocus
          v-model="serialNumber"
          :label="$t('panel.posManagementPage.activationModal.serialNumber')"
          class="fill-width"
          outlined
          hide-details
        />

        <v-btn
          color="primary"
          class="py-6 font-semiBold-16 mt-8"
          depressed
          block
          type="submit"
        >
          {{ $t("panel.posManagementPage.activationModal.submit") }}
        </v-btn>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="changeStatusModal"
      max-width="450px"
      @click:outside="closeChangeStatusModal"
    >
      <v-btn icon :ripple="false" @click="closeChangeStatusModal">
        <v-icon size="24">mdi-close</v-icon>
      </v-btn>

      <v-form ref="changeStatus" @submit.prevent="changeStatus" class="pa-6">
        <div class="font-semiBold-16 text-center mb-3">
          {{
            $t("panel.posManagementPage.changeStatusModal.suspendCaution", {
              action: actionModalText,
              gatewayType: gatewayType
            })
          }}
        </div>

        <v-textarea
          autofocus
          v-model="changeStatusDescription"
          :rules="rules"
          required
          :label="$t('panel.posManagementPage.changeStatusModal.description')"
          class="fill-width"
          outlined
          auto-grow
          rows="4"
        />

        <v-btn
          color="error"
          class="py-6 font-semiBold-16 mt-5"
          depressed
          block
          type="submit"
        >
          {{ $t("panel.posManagementPage.changeStatusModal.confirm") }}
        </v-btn>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import { gatewayService } from "@/services";
import setFiltersQueries from "@/mixins/setFilters&Queries";
import tableStatusItemColor from "@/mixins/tableStatusItemColor";
import gatewayModalsActions from "@/mixins/gatewayModalsActions";
import renderDate from "@/mixins/renderDate";
import autocompleteListLazyLoading from "@/mixins/autocompleteListLazyLoading";

export default {
  name: "pos-gateways",
  mixins: [
    setFiltersQueries,
    tableStatusItemColor,
    gatewayModalsActions,
    renderDate,
    autocompleteListLazyLoading
  ],
  data() {
    return {
      pageCount: 0,
      totalPages: 1,
      loading: false,
      shortList: false,
      filtersObj: {
        userId: "",
        businessName: "",
        serialNumber: "",
        page: 1,
        size: 10
      },
      tableFilters: [] || "",
      tableData: []
      // activationModal: false,
      // submitLoading: {},
      // gatewayId: "",
      // serialNumber: "",
      // suspensionModal: false,
      // suspendDescription: "",
      // rules: [
      //   (v) =>
      //     !!v || this.$t("panel.posManagementPage.suspensionModal.notEmpty"),
      // ],
    };
  },
  async mounted() {
    await this.$setFiltersFromQuery();
    await this.filtersSubmission(true);
    if (this.filtersObj.userId) {
      this.businessNamesList.extraKey = this.filtersObj.userId;
      await this.getUserInfo();
    }
  },
  methods: {
    getBusinessNames() {
      this.filtersObj.businessId = "";
      this.businessNamesList.extraKey = this.filtersObj.userId;
    },
    resetFilters() {
      for (let key in this.filtersObj) {
        this.filtersObj[key] = null;
      }
      this.filtersObj.page = 1;
      this.filtersObj.size = 10;
      this.filtersSubmission();
    },
    async filtersSubmission(paginationButton) {
      await this.loadData(this.$setQueryFromFilters(paginationButton));
    },
    async loadData(tableFilters) {
      this.loading = true;
      await gatewayService
        .getPosGateways(tableFilters)
        .then(response => {
          this.tableData = response.data.data.content;
          const tableDataLength = this.tableData.length;
          if (tableDataLength < 5 && tableDataLength > 0) {
            if (tableDataLength === 1) {
              this.shortList = "short-list-one-item";
            } else this.shortList = "short-list";
          } else this.shortList = "";
          this.totalPages = response.data.data.totalPages;
        })
        .finally(() => {
          this.loading = false;
        });
    }
    // openActivationModal(gatewayId) {
    //   this.gatewayId = gatewayId;
    //   this.activationModal = true;
    // },
    // openSuspensionModal(gatewayId) {
    //   this.gatewayId = gatewayId;
    //   this.suspensionModal = true;
    // },
    // closeSuspendModal() {
    //   this.gatewayId = "";
    //   this.suspendDescription = "";
    //   this.suspensionModal = false;
    // },
    // closeActiveModal() {
    //   this.gatewayId = "";
    //   this.serialNumber = "";
    //   this.activationModal = false;
    // },
    // activatePos() {
    //   this.submitLoading[this.gatewayId] = true;
    //   const model = {
    //     gatewayId: this.gatewayId,
    //     serialNumber: this.serialNumber,
    //   };
    //   gatewayService
    //     .activePos(model)
    //     .then((res) => {
    //       this.$toast.success(res.data.message);
    //       this.filtersSubmission(true);
    //       this.activationModal = false;
    //     })
    //     .finally(() => {
    //       this.submitLoading[this.gatewayId] = false;
    //     });
    // },
    // suspendPos() {
    //   if (!this.suspendDescription) {
    //     return;
    //   }
    //   this.submitLoading[this.gatewayId] = true;
    //   const model = {
    //     gatewayId: this.gatewayId,
    //     description: this.suspendDescription,
    //     gatewayStatus: "SUSPENDED",
    //   };
    //   gatewayService
    //     .suspendPos(model)
    //     .then((res) => {
    //       this.$toast.success(res.data.message);
    //       this.filtersSubmission(true);
    //       this.suspensionModal = false;
    //     })
    //     .finally(() => {
    //       this.submitLoading[this.gatewayId] = false;
    //     });
    // },
  }
};
</script>

<style scoped lang="scss">
@import "PosGateways";
</style>
